module.exports = __webpack_public_path__ + "img/cancel.a7053077.svg";